export const GET_AGENT_EMPLOYEE_LIST = 'GET_AGENT_EMPLOYEE_LIST';
export const GET_AGENT_EMPLOYEE_LIST_SUCCESS =
    'GET_AGENT_EMPLOYEE_LIST_SUCCESS';
export const GET_AGENT_EMPLOYEE_LIST_FAIL = 'GET_AGENT_EMPLOYEE_LIST_FAIL';

export const RESET_AGENT_EMPLOYEE_LIST_ERRORS =
    'RESET_AGENT_EMPLOYEE_LIST_ERRORS';
